// extracted by mini-css-extract-plugin
export default {"resource-page":"resource-page__qvub4","loader":"loader__pjpfh","moderation-flag":"moderation-flag__3Ix1x"};